export const WEBSOCKET_PATH = '/websocket';
export const WEBSOCKET_BASE_URL = process.env.VUE_APP_BASE_URL_WEBSOCKET;
export const WEBSOCKET_NAMESPACE = 'accountancy';
export const WEBSOCKET_EVENTS = {
  MONTHLY_PAYROLL_CALCULATION_SUCCESS: 'MONTHLY_PAYROLL_CALCULATION',
  PAYROLL_DCTFWEB_UPDATED_STATUS: 'PAYROLL-DCTFWEB_UPDATED_STATUS',
  PAYROLL_DCTFWEB_UPDATED_STEP: 'PAYROLL-DCTFWEB_UPDATED_STEP',
  PERSONNEL_DEPARTMENT_BACKUP_UPDATED_STATUS: 'PERSONNEL_DEPARTMENT-BACKUP_REQUEST_UPDATED_STATUS',
};
